import React from "react";

import { Context, updateSchoolAiEnabled } from "../../../managerStore";
import { titles } from "../../../constants/titles";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import LoungeSetting from "../../../templates/manager/LoungeSetting";

export default function LoungeSettingPage() {
  const { state, dispatch } = React.useContext(Context);

  const handleChangeAiEnabled = (value: boolean) => {
    // もしステータスが同じなら更新しない
    if (state.manager.school?.ai_enabled === value) {
      return;
    }
    dispatch(updateSchoolAiEnabled(value));
  };

  if (state.manager === null) {
    return <>Not Found.</>;
  }

  return (
    <>
      <Breadcrumb currentTitle={titles.loungeSetting} />
      <LoungeSetting
        title={titles.loungeSetting}
        defaultAiEnabled={state.manager.school?.ai_enabled || false}
        onChangeAiEnabled={handleChangeAiEnabled}
      />
    </>
  );
}
